import { render, staticRenderFns } from "./HistoricalMetricsDashboard.vue?vue&type=template&id=98ef9a9c&scoped=true"
import script from "./HistoricalMetricsDashboard.vue?vue&type=script&lang=js"
export * from "./HistoricalMetricsDashboard.vue?vue&type=script&lang=js"
import style0 from "./HistoricalMetricsDashboard.vue?vue&type=style&index=0&id=98ef9a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ef9a9c",
  null
  
)

export default component.exports